var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.version,{tag:"component",attrs:{"fields":_vm.fields,"active-field":_vm.activeField},on:{"change-field":_vm.setField,"clear-form":_vm.clearForm},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }